module.exports = __webpack_public_path__ + "static/img/introductionBg.9dc3f314.png";